import domReady from './shared/dom-ready';

import { init as singlePostInit } from './single-post'

import { init as timeLineInit } from './blocks/timeline';

domReady( singlePostInit );
domReady( timeLineInit );
